import {
  Button,
  Heading,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import { Form, Formik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Select from "~components/Form/components/Select";
import { ArrowRightModal } from "~misc/icons";
import { initialPath } from "~misc/paths";
import useSimulatorsNewProduct from "~pages/Simulators/hooks/useSimulatorsNewProduct";
import useSimulatorsStore from "~pages/Simulators/hooks/useSimulatorsStore";
import { Spinner } from "@chakra-ui/react";
import Loader from "~components/Form/components/Loader";
import useFilial from "~/fetchs/useFilial";
import useGrupoProduto from "~/fetchs/useGrupoProduto";
import useProduto from "~/fetchs/useProduto";
import useProdutoFilialPrecoRegraMicrorregiao from "~/fetchs/useProdutoFilialPrecoRegraMicrorregiao";
import PropTypes from "prop-types";

const ModalInfoForSimulation = ({ isOpen, onClose, validation, initial, cliente }) => {
  const { parameter: idCliente } = useParams();
  const navigate = useNavigate();
  const { setRequiredInfoForSimulation } = useSimulatorsStore();
  const [loading, setLoading] = useState(false);

  const [data, setData] = useState({});

  const formikRef = useRef();

  const { opcoesDisponiveis } = useProdutoFilialPrecoRegraMicrorregiao({
    microrregiaoId: cliente?.microrregiaoId,
    data,
  });

  const { optionFiliais, onChangeFilial, filialSelect, filial, setFilial } = useFilial({
    formikRef,
    filiaisDisponiveis: opcoesDisponiveis.filiaisIds,
    camposOpt: ["codigo", "nome"],
  });
  const { optionGruposProduto, grupoProduto, onChangeGrupoProduto, grupoProdutoSelect } = useGrupoProduto({
    formikRef,
    name: "grupoProdutoId",
    filial,
    gruposDisponiveis: opcoesDisponiveis.grupoProdutosIds,
    camposOpt: ["nome"],
  });
  const { optionProdutos, onChangeProduto, produtoSelect, produto, setIndexDBProdutoSimulacao } = useProduto({
    grupoProduto,
    formikRef,
    name: "produtoId",
    filialForm: filial,
    produtosDisponiveis: opcoesDisponiveis.produtosIds,
    camposOpt: ["codigo", "descricaoProduto"],
  });

  return (
    <Modal
      isOpen={isOpen}
      onClose={(e) => {
        if (onClose && typeof onClose == "function") onClose(e);

        setTimeout(() => {
          onChangeFilial({ label: null, value: null }, false);
          onChangeGrupoProduto({ label: null, value: null }, false);
          onChangeProduto({ label: null, value: null }, false);
        }, 100);
      }}
      size="xl"
      isCentered
    >
      <ModalOverlay />
      <ModalContent className="!rounded-[20px]">
        <ModalHeader />
        <ModalCloseButton className="!bg-[#FF2E00] !text-white !top-0 !right-0 !rounded-b-none !rounded-tl-none !rounded-tr-[20px] !w-10 !h-10" />
        <ModalBody>
          <Heading as="h4" className="font-bold !text-2xl text-center mx-auto" maxWidth="400px">
            Selecione as informações necessárias para a simulação
          </Heading>
          <Heading as="h6" size="xs" className="text-center mx-auto" maxWidth="400px" mb="8">
            <i>Caso o produto ou centro não esteja disponível, é necessário abrir CAP de cadastro de preço</i>
          </Heading>
          <Formik
            innerRef={formikRef}
            initialValues={initial}
            validationSchema={validation}
            onSubmit={async (values) => {
              try {
                setLoading(true);
                setIndexDBProdutoSimulacao(idCliente, values);
                navigate(`${initialPath}/simuladores/simulacao/${idCliente}/novo-produto`).then(() => {
                  setLoading(false);
                });
              } finally {
                setLoading(false);
              }
            }}
          >
            {({ errors, touched, ...rest }) => (
              <Form className="relative">
                <div className={loading ? "relative spinner__form-active" : "relative"}>
                  <Select
                    name="filialId"
                    label="Centro/Filial"
                    placeholder=""
                    options={optionFiliais}
                    noOptionsMessage="Centro/Filial não encontrado"
                    onChange={(e) => {
                      onChangeGrupoProduto({ label: null, value: null }, false);
                      onChangeProduto({ label: null, value: null }, false);
                      onChangeFilial(e);
                      setData({ ...data, filial: e.value });
                    }}
                    errors={errors.filialId}
                    touched={touched.filialId}
                    {...filialSelect}
                  />
                  <Select
                    name="grupoProdutoId"
                    label="Grupo de Produto"
                    placeholder=""
                    options={optionGruposProduto}
                    noOptionsMessage="Grupo de produto não encontrado"
                    onChange={(e) => {
                      onChangeProduto({ label: null, value: null }, false);
                      setData({ ...data, grupoProduto: e.value });
                      onChangeGrupoProduto(e);
                    }}
                    errors={errors.grupoProdutoId}
                    touched={touched.grupoProdutoId}
                    isDisabled={!filial}
                    {...grupoProdutoSelect}
                  />
                  <Select
                    name="produtoId"
                    label="Produto"
                    placeholder=""
                    options={optionProdutos}
                    noOptionsMessage="produto não encontrado"
                    onChange={onChangeProduto}
                    errors={errors.produtoId}
                    touched={touched.produtoId}
                    isDisabled={!grupoProduto}
                    {...produtoSelect}
                  />
                  <Button
                    type="submit"
                    variant="ghost"
                    className="ml-auto !table my-6"
                    _hover={{ background: "transparent" }}
                    disabled={loading || !filial || !grupoProduto || !produto}
                  >
                    <ArrowRightModal />
                  </Button>
                </div>
                {loading && (
                  <div className="spinner__form ">
                    <Loader />
                  </div>
                )}
              </Form>
            )}
          </Formik>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

ModalInfoForSimulation.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  validation: PropTypes.any,
  initial: PropTypes.object,
  cliente: PropTypes.shape({
    microrregiaoId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
};

export default ModalInfoForSimulation;
